import React from 'react';
import { Link } from 'react-router-dom';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import { URLS } from 'rebook/apps/base/constants';

import { UserBooksIcon, ActiveUserBooksIcon } from './images/books';
import HeaderUserMenu from '../HeaderUserMenu';
import styles from './style.scss';


const IndicatorsContainer = () => (
  <svg width="13" height="8" xmlns="http://www.w3.org/2000/svg">
    <path
      // eslint-disable-next-line max-len
      d="M5.309 6.38L.76 1.816A.854.854 0 0 1 1.967.608l4.557 4.557 4.51-4.51a.852.852 0 0 1 1.206 1.207l-5.758 5.78-1.2-1.236.027-.025z"
      fill="#BE5B04" />
  </svg>
);


class HeaderUserClickOutsideWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
    };
  }

  handleClickOutside() {
    this.setState({ isOpened: false });
  }

  toggleMenu() {
    this.setState((prevState) => {
      return { isOpened: !prevState.isOpened };
    });
  }

  render() {
    const { user } = this.props;
    return (
      <div>
        <div
          className={classNames([
            'jest-header-user-icon',
            styles.userIcon,
            this.state.isOpened ? styles.menuOpened : null,
          ])}
          onClick={() => this.toggleMenu()}>
          <CroppedImage src={user.avatar} width={32} height={32} className={styles.avatar} />
          <IndicatorsContainer />
        </div>
        {this.state.isOpened
          ? (
            <HeaderUserMenu user={user} onCloseMenu={()=>{this.toggleMenu();}} pathname={this.props.pathname} />
          )
          :
          null
        }
      </div>
    );
  }
}

HeaderUserClickOutsideWrapper = onClickOutside(HeaderUserClickOutsideWrapper);

const HeaderUser = ({ user, pathname }) => {
  const activeLink = pathname.indexOf(URLS.profile) !== -1;
  return (
    <div className={styles.container}>
      <Link to={`/profile/${user.id}/`} className={classNames(
        styles.link,
        { activeLink }
      )}>
        <div className={classNames(
          styles.headerUserBooksImage,
          'jest-user-books-mobile-button')}>
          {activeLink && <ActiveUserBooksIcon />}
          {!activeLink && <UserBooksIcon />}
        </div>
      </Link>
      <HeaderUserClickOutsideWrapper user={user} pathname={pathname} />
    </div>
  );
};

export default HeaderUser;
